/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GameResultsDto } from '../models/GameResultsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GameService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns GameResultsDto
     * @throws ApiError
     */
    public saveGameResults(
        requestBody: GameResultsDto,
    ): CancelablePromise<GameResultsDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/game/results',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns GameResultsDto
     * @throws ApiError
     */
    public getGameResults(): CancelablePromise<GameResultsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/game/results',
        });
    }

    /**
     * @param patient
     * @returns GameResultsDto
     * @throws ApiError
     */
    public getGameResultsForPatient(
        patient: string,
    ): CancelablePromise<GameResultsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/game/results/{patient}',
            path: {
                'patient': patient,
            },
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public getGeneralStats(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/game/stats',
        });
    }

}
